module.exports = __webpack_public_path__ + "img/screen-8.fb75368e.png";